import { Channel, DictionaryNames, ReservationType } from './enums';
export const DO_NOT_NOTIFY = 'do not notify';
export const ehrPrimaryChannels = [
    DO_NOT_NOTIFY,
    Channel.FaceBook,
    Channel.ChaikaTgBot,
    Channel.Viber,
    Channel.Sms,
    Channel.Email,
    Channel.WhatsApp,
    Channel.Default,
];
export const userPrimaryChannels = [
    DO_NOT_NOTIFY,
    Channel.FaceBook,
    Channel.ChaikaTgBot,
    Channel.TelegramName,
    Channel.Viber,
    Channel.Sms,
    Channel.Email,
    Channel.WhatsApp,
    Channel.ContactEmail,
];
export const sendMessageChannels = [
    Channel.ChaikaTgBot,
    Channel.Viber,
    Channel.Sms,
    Channel.Email,
    Channel.WhatsApp,
    Channel.Default,
    Channel.TgNotificationTopic,
];
export const doctorScheduleReservationTypes = [
    ReservationType.Appointment,
    ReservationType.OnlineAppointment,
    ReservationType.TimeBlock,
    ReservationType.RoomBooking,
];
export function isAuditEntityType(event, entityType) {
    return event.startsWith(entityType);
}
export const EHR_VIEW_CONTEXT_HEADER = 'x-ehr-view-context';
// Типы записей
export const SOAP_SUBJECTIVE_ENTRY_TYPE_ID = '1628a36f-616f-4f05-b4e9-7405974d6d33';
export const SOAP_ASSESSMENT_ENTRY_TYPE_ID = '52c35577-b046-4876-ba93-039176e3d94e';
export const SOAP_PLAN_ENTRY_TYPE_ID = '71f3588b-73b7-4ebe-8e60-86002b9f5e53';
export const SOAP_PAYMENT_ENTRY_TYPE_ID = '6fb3eca0-caaa-4ea6-a7c2-4c5b60a252cf';
export const COMMON_LAB_ENTRY_TYPE_ID = '6209f7d4-56f5-42bd-9794-487d3f2754ec';
export const COMMON_LAB_ENTRY_TYPE_WITH_INTERNAL_ID = '4399c8b9-46cd-43b3-9016-55e0e5ece57f';
// Дата запуска SOAP-формы. Запись считается SOAP-форматной, если creationTime строго после неё.
export const SOAP_LAUNCH_DAY = '2025-06-25T00:00:00.000Z';
export const COMMUNICATION_ENTRY_TYPE_ID = '100a7243-f529-44df-9bb2-4a276d062cc7';
export const ATTACHED_DOCUMENT = 'daa7b1b3-331c-4492-8697-67f63b1e4484';
export const FINNED_ENTRY = 'e125b1aa-2da6-4757-81cb-df3ce513acfa';
// Чайка-бот — системный автор записей, созданных из чатов с пациентом
export const CHAIKA_BOT_USER_ID = '8eb11cc6-7411-45b9-9a0d-fb222920cbfa';
export const ENTRY_TYPE_IDS_WITHOUT_RENDERED_SERVICES = [
    COMMUNICATION_ENTRY_TYPE_ID,
    ATTACHED_DOCUMENT,
    '888934ad-44d0-40a5-86b6-0f8f870a29af',
    'c555f909-d6e9-4037-8131-b4094ee4e0b4',
    '9488c750-f0a1-4800-9f79-d639b2f5db8e',
];
export const ENTRY_TYPE_IDS_WITHOUT_EDS = [
    COMMUNICATION_ENTRY_TYPE_ID,
    ATTACHED_DOCUMENT,
    FINNED_ENTRY,
    COMMON_LAB_ENTRY_TYPE_ID,
    COMMON_LAB_ENTRY_TYPE_WITH_INTERNAL_ID,
    'af5036ba-c9ec-453c-86a4-82c54291db2f',
    '11c865db-b699-4564-ba75-01cbf20c0d96',
];
// Test data
export const TestEntitiesIds = {
    UserId: '62f44f0c-bdfd-4cf7-a266-012b1ff18b0a',
    LegalEntityId: '69a90806-af44-4736-bec0-22157950833f',
    ClinicLegalEntityId: '8d3a2b1c-5e4f-4a6d-9b8c-7e2f1a3d5c6b',
    InsuranceLegalEntityId: 'dec17510-0001-4001-8001-000000000001',
    OrganizationId: '1e7b7921-9bde-4961-93bb-4e3078dfafcc',
    EhrId: '135471b8-8bc5-4288-af46-f7cbe7a4e5ec',
    ServiceId: '33ad43ab-b729-4bee-adda-e115e3ba19b6',
    EntryId: 'c8ea7754-60d6-44c6-829c-9031ac29e003',
    OfficeId: '28729942-3140-4b6b-bfcf-ae0ac20374f4',
    OfficeTypeId: 'a4d2e2bd-9aa8-4f2b-8c1a-3f5d4d6e7a82',
    EntryTypeId: 'e9f19588-009c-40db-b629-21827e966dbd',
    DictionaryId: 'bbce2c7a-f6b5-4be1-b5e1-c56e54a6428f',
    ProtestId: '744ac784-9b4f-48c1-8693-df7d837d7e4c',
    ProtestItemId: 'a79a24aa-e7e6-4d2f-b2b4-52b2e48e981f',
    SpecialtyId: 'd4f9b1a2-3c5e-4a7b-8c9d-1e2f3a4b5c6d',
    EpisodeNameDictionaryItem1Id: 'e1f2a3b4-c5d6-4e7f-8a9b-0c1d2e3f4a5b',
    EpisodeNameDictionaryItem2Id: 'e1f2a3b4-c5d6-4e7f-8a9b-0c1d2e3f4a5c',
    SpecialtyEpisodeNameId: 'f1e2d3c4-b5a6-4978-8c7d-6e5f4a3b2c1d',
    ClinicContractId: 'dec17510-0002-4002-8002-000000000002',
    InsuranceContractId: 'dec17510-0003-4003-8003-000000000003',
    SubscriptionPlanId: 'dec17510-0004-4004-8004-000000000004',
    InsurancePlanId: 'dec17510-0005-4005-8005-000000000005',
    PlanSubscriptionId: 'dec17510-0006-4006-8006-000000000006',
    ReservationId: 'dec17510-0008-4008-8008-000000000008',
    ScheduleShiftId: 'dec17510-0031-4031-8031-000000000031',
    ScheduleRuleId: 'dec17510-0032-4032-8032-000000000032',
    PracticeClinicId: 'dec17510-0009-4009-8009-000000000009',
    PracticeId: 'dec17510-000a-400a-800a-00000000000a',
    PracticeMemberId: 'dec17510-000b-400b-800b-00000000000b',
    PricedServiceAId: 'dec17510-000c-400c-800c-00000000000c',
    PricedServiceBId: 'dec17510-000d-400d-800d-00000000000d',
    CompositeParentServiceId: 'dec17510-000e-400e-800e-00000000000e',
    LabServiceId: 'dec17510-000f-400f-800f-00000000000f',
    Laboratory1Id: 'dec17510-0010-4010-8010-000000000010',
    Laboratory2Id: 'dec17510-0011-4011-8011-000000000011',
    LaboratoryService1Id: 'dec17510-0012-4012-8012-000000000012',
    LaboratoryService2Id: 'dec17510-0013-4013-8013-000000000013',
    InsuranceLegalEntity2Id: 'dec17510-0014-4014-8014-000000000014',
    InsuranceContract2Id: 'dec17510-0015-4015-8015-000000000015',
    CoveringInsurancePlanAId: 'dec17510-0016-4016-8016-000000000016',
    CoveringInsurancePlanBId: 'dec17510-0017-4017-8017-000000000017',
    CoveringInsuranceSubscriptionAId: 'dec17510-0018-4018-8018-000000000018',
    CoveringInsuranceSubscriptionBId: 'dec17510-0019-4019-8019-000000000019',
    PatientsProgramPlanId: 'dec17510-001a-401a-801a-00000000001a',
    PatientsProgramSubscriptionId: 'dec17510-001b-401b-801b-00000000001b',
    IndividualPlanId: 'dec17510-001c-401c-801c-00000000001c',
    IndividualPlanSubscriptionId: 'dec17510-001d-401d-801d-00000000001d',
    InsurancePriceList1Id: 'dec17510-001e-401e-801e-00000000001e',
    InsurancePriceList2Id: 'dec17510-001f-401f-801f-00000000001f',
    DeviceTypeId: 'dec17510-0020-4020-8020-000000000020',
    CheckupPlanId: 'dec17510-0021-4021-8021-000000000021',
    CheckupServiceId: 'dec17510-0022-4022-8022-000000000022',
    GpConsultEntryId: 'dec17510-0024-4024-8024-000000000024',
    GpConsultMedicalCaseId: 'dec17510-0025-4025-8025-000000000025',
    DoctorUserId: 'dec17510-0026-4026-8026-000000000026',
    GpDrugDictionaryItemId: 'dec17510-0027-4027-8027-000000000027',
    GpServiceId: 'dec17510-0028-4028-8028-000000000028',
    GpIcdDictionaryItemId: 'dec17510-0029-4029-8029-000000000029',
    GpSpecialtyId: 'dec17510-0030-4030-8030-000000000030',
    CardiologistConsultationServiceId: 'dec17510-0031-4031-8031-000000000031',
    CardiologistFollowUpServiceId: 'dec17510-0032-4032-8032-000000000032',
    SignedEntryId: 'dec17510-0023-4023-8023-000000000023',
};
export const TestEntitiesData = {
    UserEmail: 'admin@chaika.com',
    UserPassword: 'admin-test-password',
    ServiceName: 'serviceName',
    ServiceEnName: 'serviceEnName',
    ServiceGeName: 'serviceGeName',
    DictionaryName: DictionaryNames.Mkb10,
    DictionaryTitle: 'dictionaryTitle',
    DictionaryTitleEn: 'dictionaryTitleEn',
    DictionaryTitleAm: 'dictionaryTitleAm',
    ProtestActNumber: '0',
    SpecialtyName: 'E2E Specialty',
    EpisodeNameTitleMapped: 'E2E Episode Mapped',
    EpisodeNameTitleUnmapped: 'E2E Episode Unmapped',
    PricedServiceAName: 'E2E Priced Service A',
    PricedServiceBName: 'E2E Priced Service B',
    CompositeParentServiceName: 'E2E Composite Service',
    LabServiceName: 'E2E Lab Panel',
    Laboratory1Name: 'E2E Laboratory One',
    Laboratory2Name: 'E2E Laboratory Two',
    InsuranceLegalEntity2Name: 'АО «Страховой Альбатрос»',
    CheckupServiceName: 'E2E Checkup Service',
    CardiologistConsultationServiceName: 'Консультация кардиолога',
    CardiologistFollowUpServiceName: 'Повторная консультация кардиолога',
};
export const SSE_CHANNEL = 'sse_channel';
export const BFF_SSE_CHANNEL = 'bff:server-events';
export const infrastructureDivisionId = '3499af0b-a58a-4e1e-9e57-eb168b9b4ebb';
